import React from 'react';
import PropTypes from 'prop-types';

const categoryButtonStyle = {
  color: '#37455b',
  fontSize: '14px',
  fontWeight: 'bold',
  width: '100%',
  textAlign: 'left',
  overflow: 'visible',
};

export default class NavSideBarListSectionHeader extends React.PureComponent {
  render() {
    let content = this.props.children;

    if (this.props.onClick) {
      content = (
        <button
          className={`nav-header-button ${this.props.className}`}
          style={categoryButtonStyle}
          onClick={this.props.onClick}
        >
          {this.props.children}
        </button>
      );
    }

    return (
      <li className={`nav-header ${this.props.className}`}>
        {content}
      </li>
    );
  }
}

NavSideBarListSectionHeader.defaultProps = {
  onClick: null,
  className: '',
};

NavSideBarListSectionHeader.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarList/NavSideBarListSectionHeader.jsx